import React, { useEffect, useState } from 'react';
import { Button, FormGroup, FormText, Input, Label, Modal, ModalBody, InputGroup, InputGroupAddon } from 'reactstrap';

export const ConfirmCurrentPasswordModal = ({ isOpen, toggle, setCurrentPassword, error, onAccept }) => {
    useEffect(() => {
        if(!isOpen) {
            setCurrentPassword('')
        }
    }, [isOpen])

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalBody>
                <div className="text-center mb-3">
                    <h2 className="libre-caslon-text-regular h4-md h5">Confirm Email Update</h2>
                    <Label for="password">Enter your Current Password to confirm new email update</Label>
                </div>
                <FormGroup>
                    <InputGroup size='lg' className='flex-row-reverse'>
                        <Input
                            type="password"
                            name="currentPassword"
                            id="currentPassword"
                            onChange={(e) => { setCurrentPassword(e.target.value) }}
                            className='border-left-0 pl-0'
                            placeholder='Enter Current Password'
                        />
                        <InputGroupAddon addonType='prepend'>
                            <span className={`input-group-text pl-3 pr-2 text-muted`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} viewBox="0 0 16 17" fill='currentColor'>
                                <path d="M13.7,5.8c-0.2-0.2-0.4-0.3-0.7-0.3h-2V4c0-0.8-0.3-1.6-0.9-2.1C9.6,1.3,8.8,1,8,1S6.4,1.3,5.9,1.9
                                    C5.3,2.4,5,3.2,5,4v1.5H3c-0.3,0-0.5,0.1-0.7,0.3C2.1,6,2,6.2,2,6.5v7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h10
                                    c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-7C14,6.2,13.9,6,13.7,5.8z M8.8,10c0,0.2-0.1,0.4-0.2,0.5S8.2,10.8,8,10.8
                                    c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.3,0-0.4c0-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.2
                                    c0.1,0,0.3,0,0.4,0c0.1,0.1,0.3,0.2,0.3,0.3C8.7,9.7,8.8,9.9,8.8,10z M8,2c0.5,0,1,0.2,1.4,0.6S10,3.5,10,4v1.5H6V4
                                    c0-0.5,0.2-1,0.6-1.4C7,2.2,7.5,2,8,2z"/>
                                </svg>
                            </span>
                        </InputGroupAddon>
                    </InputGroup>
                    {error && <FormText>{error}</FormText>}
                </FormGroup>
                <div className='botones d-flex col-12 justify-content-center'>
                    <Button color='green-light' size='sm' className='mx-2 text-nowrap' onClick={onAccept} disabled={!!error}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-2'>
                        <path d="M13.2,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                            L2.2,8.3C2.2,8.3,2.1,8.2,2.1,8.1C2,8,2,8,2,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                            c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.7,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                            c0.1,0.1,0.2,0.3,0.2,0.5C13.4,4.1,13.3,4.3,13.2,4.4L13.2,4.4z"/>
                        </svg>
                        Confirm Changes
                    </Button>
                    <Button color='outline-green-light' size='sm' className='mx-2 text-nowrap' onClick={toggle} >
                        <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-2'>
                        <path d="M11.9,10.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                            L7.5,7.9L4,11.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5L6.6,7L3.1,3.5
                            C3,3.4,2.9,3.2,2.9,3.1S3,2.7,3.1,2.6c0.1-0.1,0.3-0.2,0.5-0.2S3.9,2.5,4,2.6l3.5,3.5L11,2.6c0.1-0.1,0.3-0.2,0.5-0.2
                            c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5S12,3.4,11.9,3.5L8.4,7L11.9,10.5z"/>
                        </svg>
                        Discard Changes
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}